<div class="container-fluid" style="position: relative; height: 100vh; padding-left: 3rem;">
  <div class="d-flex justify-content-center mt-5 mb-5" *ngIf="isPendingRequestShow;">

    <div class="col-md-11 user-table position-relative">
      <div *ngIf="loading || initialLoading" class="position-absolute top-50 start-50 translate-middle">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>


      <mdb-tabs (activeTabChange)="getAdminPendingUserList($event)" *ngIf="role == 'admin'">
        <mdb-tab title="FinTech Normal Users">

          <div class="table-container">

            <div class="row p-3 position-relative align-self">
              <div class="col-md">
                <mdb-form-control>
                  <select [(ngModel)]="selectedFilter" ngDefaultControl class="form-select"
                    aria-label="Default select example">
                    <option *ngFor="let filter of filters" [value]="filter.value">{{filter.name}}</option>
                  </select>
                </mdb-form-control>
              </div>
              <div class="col-md">

                <mdb-form-control class="d-flex align-items-center">
                  <input mdbInput type="search" id="form1" class="form-control mr-2" [(ngModel)]="filterText"
                    ngDefaultControl
                    (ngModelChange)="loadDetails( 1,pa, selectedFilter, filterText, sortOrder,sortBy)" />
                  <label mdbLabel class="form-label p-1" for="form1">Search</label>
                </mdb-form-control>
              </div>
            </div>
            <table class="table table-sm" [ngClass]="loading ? 'blur-background' : ''">
              <thead>
                <tr>

                  <th [(ngModel)]="sortBy" ngDefaultControl
                    (click)="sortBy = 'username'; loadDetails( 1,pa, selectedFilter, filterText, toggleSortDirection(),sortBy)"
                    class="header-button">Username
                    <span [(ngModel)]="sortOrder" ngDefaultControl [ngClass]="{'arrow-up': sortBy === 'username' && sortOrder === 'ascending',
                         'arrow-down': sortBy === 'username' && sortOrder === 'descending'}"></span>
                  </th>

                  <th
                    (click)="sortBy = 'fullName'; loadDetails( 1,pa, selectedFilter, filterText, toggleSortDirection(),sortBy)"
                    class="header-button">Full Name
                    <span [ngClass]="{'arrow-up': sortBy === 'fullName' && sortOrder === 'ascending',
                         'arrow-down': sortBy === 'fullName' && sortOrder === 'descending'}"></span>
                  </th>

                  <th
                    (click)="sortBy = 'email'; loadDetails( 1,pa, selectedFilter, filterText, toggleSortDirection(),sortBy)"
                    class="header-button">Email
                    <span [ngClass]="{'arrow-up': sortBy === 'email' && sortOrder === 'ascending',
                         'arrow-down': sortBy === 'email' && sortOrder === 'descending'}"></span>
                  </th>

                  <th
                    (click)="sortBy = 'company'; loadDetails(1, pa, selectedFilter, filterText, toggleSortDirection(),sortBy)"
                    class="header-button">Company
                    <span [ngClass]="{'arrow-up': sortBy === 'company' && sortOrder === 'ascending',
                         'arrow-down': sortBy === 'company' && sortOrder === 'descending'}"></span>
                  </th>

                  <th
                    (click)="sortBy = 'requestDate'; loadDetails( 1,pa, selectedFilter, filterText, toggleSortDirection(),sortBy)"
                    class="header-button">Request Date
                    <span [ngClass]="{'arrow-up': sortBy === 'requestDate' && sortOrder === 'ascending',
                         'arrow-down': sortBy === 'requestDate' && sortOrder === 'descending'}"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let broker of pendingRequestData | paginate: { itemsPerPage: itemsPerPage, currentPage: pa, totalItems: pendingRequestsResponse?.totalNoOfRecords }">
                  <td class="shorten-text">{{broker.username == null ? 'N/A' : broker.username}}</td>
                  <td scope="row" class="shorten-text">{{broker.firstName}} {{broker.lastName}}</td>
                  <td class="shorten-text">{{broker.email}}</td>
                  <td class="shorten-text">{{broker.company}}</td>
                  <td class="shorten-text">{{broker.requestDate}}</td>


                  <td class="d-flex justify-content-end">
                    <button type="button" class="btn btn-outline-info" style="margin-right: 20px;"
                      (click)="viewBroker(broker)">
                      More
                    </button>
                    <div class="btn-group btn-group-sm" role="group" aria-label="Basic mixed styles example">

                      <button type="button" class="btn btn-primary" (click)="approveBroker(broker, 1)"><i
                          class="custom-icon-button1"></i></button>
                      <button type="button" class="btn btn-danger"
                        (click)="onRejectPress(broker.id, broker.username)"><i class="custom-icon-button2"></i></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>




          <div class="position-absolute bottom-0 start-0 p-4">
            <div class="hstack gap-3">
              <div>
                Entries per page
              </div>
              <div mdbDropdown class="dropdown">
                <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton"
                  aria-expanded="false" mdbDropdownToggle>
                  {{itemsPerPage}}
                </button>
                <ul mdbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <li><a class="dropdown-item" (click)="pageSizeChanged(10)">10</a></li>
                  <li><a class="dropdown-item" (click)="pageSizeChanged(20)">20</a></li>
                  <li><a class="dropdown-item" (click)="pageSizeChanged(50)">50</a></li>
                  <li><a class="dropdown-item" (click)="pageSizeChanged(100)">100</a></li>
                </ul>
              </div>
            </div>

          </div>

          <div class="position-absolute bottom-0 end-0 p-4">
            <pagination-template id="broker" #p="paginationApi" (pageChange)="pageChanged($event)">
              <nav>
                <ul class="pagination">
                  <li class="page-item" style="cursor: pointer;" [ngClass]="p.isFirstPage() ? 'disabled' : ''">
                    <a (click)="p.previous()" class="page-link">Previous</a>
                  </li>

                  <div *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
                    <li class="page-item" style="cursor: pointer;"
                      [ngClass]="p.getCurrent() === page.value ? 'active' : ''"><a (click)="p.setCurrent(page.value)"
                        class="page-link">{{ page.label }}</a></li>
                  </div>

                  <li class="page-item" style="cursor: pointer;" [ngClass]="p.isLastPage() ? 'disabled' : ''">
                    <a class="page-link" (click)="p.next()"> Next </a>
                  </li>
                </ul>
              </nav>
            </pagination-template>
          </div>
        </mdb-tab>

        <mdb-tab title="FinTech Internal Users">

          <div class="table-container">

            <div class="row p-3 position-relative align-self">
              <div class="col-md">
                <mdb-form-control>
                  <select [(ngModel)]="selectedFilter" ngDefaultControl class="form-select"
                    aria-label="Default select example">
                    <option *ngFor="let filter of filtersForInternalUsers" [value]="filter.value">{{filter.name}}
                    </option>
                  </select>
                </mdb-form-control>
              </div>
              <div class="col-md">

                <mdb-form-control class="d-flex align-items-center">
                  <input mdbInput type="search" id="form2" class="form-control mr-2" [(ngModel)]="filterText"
                    ngDefaultControl
                    (ngModelChange)="loadDetails( 5,pa, selectedFilter, filterText, sortOrder,sortBy)" />
                  <label mdbLabel class="form-label p-1" for="form1">Search</label>
                </mdb-form-control>
              </div>
            </div>
            <table class="table table-sm" [ngClass]="loading ? 'blur-background' : ''">
              <thead>
                <tr>

                  <th [(ngModel)]="sortBy" ngDefaultControl
                    (click)="sortBy = 'username'; loadDetails(5, pa, selectedFilter, filterText, toggleSortDirection(),sortBy)"
                    class="header-button">Username
                    <span [(ngModel)]="sortOrder" ngDefaultControl [ngClass]="{'arrow-up': sortBy === 'username' && sortOrder === 'ascending',
                         'arrow-down': sortBy === 'username' && sortOrder === 'descending'}"></span>
                  </th>

                  <th
                    (click)="sortBy = 'fullName'; loadDetails(5, pa, selectedFilter, filterText, toggleSortDirection(),sortBy)"
                    class="header-button">Full Name
                    <span [ngClass]="{'arrow-up': sortBy === 'fullName' && sortOrder === 'ascending',
                         'arrow-down': sortBy === 'fullName' && sortOrder === 'descending'}"></span>
                  </th>

                  <th
                    (click)="sortBy = 'email'; loadDetails(5, pa, selectedFilter, filterText, toggleSortDirection(),sortBy)"
                    class="header-button">Email
                    <span [ngClass]="{'arrow-up': sortBy === 'email' && sortOrder === 'ascending',
                         'arrow-down': sortBy === 'email' && sortOrder === 'descending'}"></span>
                  </th>

                  <th
                    (click)="sortBy = 'requestDate'; loadDetails(5, pa, selectedFilter, filterText, toggleSortDirection(),sortBy)"
                    class="header-button">Request Date
                    <span [ngClass]="{'arrow-up': sortBy === 'requestDate' && sortOrder === 'ascending',
                         'arrow-down': sortBy === 'requestDate' && sortOrder === 'descending'}"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let broker of pendingInternalUserRequestData | paginate: { itemsPerPage: itemsPerPage, currentPage: pa, totalItems: pendingInternalUserRequestsResponse?.totalNoOfRecords }">
                  <td class="shorten-text">{{broker.username == null ? 'N/A' : broker.username}}</td>
                  <td scope="row" class="shorten-text">{{broker.firstName}} {{broker.lastName}}</td>
                  <td class="shorten-text">{{broker.email}}</td>
                  <td class="shorten-text">{{broker.requestDate}}</td>


                  <td class="d-flex justify-content-end">
                    <button type="button" class="btn btn-outline-info" style="margin-right: 20px;"
                      (click)="viewBroker(broker)">
                      More
                    </button>
                    <div class="btn-group btn-group-sm" role="group" aria-label="Basic mixed styles example">

                      <button type="button" class="btn btn-primary" (click)="approveInternalUser(broker,5)"><i
                          class="custom-icon-button1"></i></button>
                      <button type="button" class="btn btn-danger"
                        (click)="onInternalUserRejectPress(broker.id, broker.username)"><i
                          class="custom-icon-button2"></i></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="position-absolute bottom-0 start-0 p-4">
            <div class="hstack gap-3">
              <div>
                Entries per page
              </div>
              <div mdbDropdown class="dropdown">
                <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2"
                  aria-expanded="false" mdbDropdownToggle>
                  {{itemsPerPage}}
                </button>
                <ul mdbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                  <li><a class="dropdown-item" (click)="pageSizeChangedForInternalUser(10)">10</a></li>
                  <li><a class="dropdown-item" (click)="pageSizeChangedForInternalUser(20)">20</a></li>
                  <li><a class="dropdown-item" (click)="pageSizeChangedForInternalUser(50)">50</a></li>
                  <li><a class="dropdown-item" (click)="pageSizeChangedForInternalUser(100)">100</a></li>
                </ul>
              </div>
            </div>

          </div>

          <div class="position-absolute bottom-0 end-0 p-4">
            <pagination-template id="internalUser" #p="paginationApi" (pageChange)="pageChangedForInternalUser($event)">
              <nav>
                <ul class="pagination">
                  <li class="page-item" style="cursor: pointer;" [ngClass]="p.isFirstPage() ? 'disabled' : ''">
                    <a (click)="p.previous()" class="page-link">Previous</a>
                  </li>

                  <div *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
                    <li class="page-item" style="cursor: pointer;"
                      [ngClass]="p.getCurrent() === page.value ? 'active' : ''"><a (click)="p.setCurrent(page.value)"
                        class="page-link">{{ page.label }}</a></li>
                  </div>

                  <li class="page-item" style="cursor: pointer;" [ngClass]="p.isLastPage() ? 'disabled' : ''">
                    <a class="page-link" (click)="p.next()"> Next </a>
                  </li>
                </ul>
              </nav>
            </pagination-template>
          </div>
        </mdb-tab>
      </mdb-tabs>

    </div>
  </div>
</div>

<!--<ng-template #message class="d-flex mt-5 mb-5">-->
<!--  <div class="d-flex justify-content-center mt-5 mb-5">-->
<!--    <div class="form-label">-->
<!--      <img src="assets/img/empty_data_icon.png" alt="empty data icon" style="width: 200px; height: 200px"/>-->
<!--      <h1 class="nodata-message ">No content found!</h1>-->
<!--    </div>-->
<!--  </div>-->
<!--</ng-template>-->